import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { MomentModule } from 'angular2-moment';
import { MDBBootstrapModulePro } from 'libs/mdbootstrap/typescripts/pro/index';
import { MDBBootstrapModule } from 'libs/mdbootstrap/typescripts/free/index';
import { ProcessService } from 'app/core/process/process.service';
import { CoreModule } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { ModalModule } from 'app/modal/modal.module';
import { ExecuteProcessComponent } from 'app/executeProcess/executeProcess.component';
import { ExecuteProcessRoutingModule } from 'app/executeProcess/executeProcess-routing.module';

@NgModule({
  imports: [
    MDBBootstrapModule,
    MDBBootstrapModulePro,
    CommonModule,
    BrowserModule,
    TranslateModule,
    MomentModule,
    CoreModule,
    SharedModule,
    ModalModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ExecuteProcessRoutingModule
  ],
  declarations: [
    ExecuteProcessComponent
  ],
  providers: [
    ProcessService
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class ExecuteProcessModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/executeProcess/executeProcess.module.ts